import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { PlansManagementService } from '../../../../shared/services/plans-management.service';

@Injectable({
  providedIn: 'root'
})
export class ReviewPlanResolver implements Resolve<boolean> {
  constructor(
    private plansManagementService: PlansManagementService,
    private router: Router
    ) {

  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return  this._getNbs();
  }

  private _getNbs(): Observable<any> {
    return this.plansManagementService.getNbs().pipe(catchError(() => {
      return of(false)
    }));
  }
}
